module.exports = __webpack_public_path__ + "static/go:reactChat-94d5f9eaa843d748edd135ef8179894f.png";